export default "__VITE_ASSET__DpS$aRmz__"